import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/src/components/common/Footer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/src/components/common/Header.tsx");
